import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import AccountClosed from "./account-closed";
import Views from "./views";
import Locked from "./locked";
import SupportRequest from "./supportRequest";

import AccountInactive from "./account-inactive";
import { Route, Switch } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from "./configs/AppConfig";
import AppErrorBoundary from "./AppErrorBoundary";
import Page404 from "./404";
import "./locales";
import "./assets/css/orderBumpShared.css"; //TODO: Fix path
import "./assets/css/custom.css";
import "./assets/css/sp-alert.css"; // global Style v3 skin for AntD <Alert> (add `sp-alert`)
import "./assets/css/sp-btn.css"; // global Style v3 button (add `sp-btn`); applied per-button on request
import "./assets/css/sp-steps.css"; // global Style v3 skin for AntD <Steps> (add `sp-steps`)
import "./assets/css/sp-tabs.css"; // global Style v3 skin for AntD <Tabs> section bar (add `sp-tabs`)
import "./assets/css/sp-confirm.css"; // global Style v3 skin for AntD Modal.confirm/.error/.warning/.info/.success (app-wide, no opt-in class)
import "./assets/css/sp-imgcrop.css"; // global Style v3 skin for the antd-img-crop "Ajustar imagem" modal (app-wide, targets .img-crop-modal)
import "./assets/css/sp-tag.css"; // global Style v3 tag/pill/status chip (add `sp-tag` + a hue); the standard - never reinvent per surface
import "./assets/css/sp-tone-tag.css"; // global themed status tag (add `sp-tone-tag` + inline --sp-tone); rich-palette sibling of sp-tag
import "./assets/css/sp-filter-chip.css"; // global filter toggle chip (add `sp-filter-chip`); the interactive list filter, not a static label
import "./assets/css/sp-surface.css"; // global Style v3 page scaffolding: aurora hero band (`sp-band`), section header (`sp-eyebrow`/`sp-section-title`) + ink tokens
import "./custom.css";
import UpdateNotification from "./components/UpdateNotification";

const themes = {
  dark: `/css/dark-theme.css`,
  light: `/css/light-theme.css`,
};

function App() {
  // Please make sure to call this method only once!
  // Gleap.initialize("waMxrYs4qcDtlBqIab9djCpf6IsMtWkr");
  // Gleap.setLanguage("pt");

  return (
    <div className="App">
      <AppErrorBoundary>
        <Provider store={store}>
          <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
            <Router>
              <Switch>
                <Route exact path="/404" component={Page404} />
                <Route exact path="/locked" component={Locked} />
                <Route exact path="/support-request" component={SupportRequest} />
                <Route exact path="/account-closed" component={AccountClosed} />
                <Route
                  exact
                  path="/feedback"
                  render={() => {
                    window.location.href = "https://salespark.featurebase.app";
                    return null;
                  }}
                />
                <Route
                  exact
                  path="/help"
                  render={() => {
                    window.location.href = "https://ajuda.salespark.io";
                    return null;
                  }}
                />
                <Route exact path="/wa-buddy-help" component={SupportRequest} />

                <Route exact path="/account-inactive" component={AccountInactive} />

                <Route path="/" component={Views} />
              </Switch>
            </Router>
          </ThemeSwitcherProvider>
        </Provider>

        <UpdateNotification
          title="Nova versão disponível"
          description="Atualiza a página para teres acesso à última versão atualizada"
          buttonText="Atualizar agora"
        />
      </AppErrorBoundary>
    </div>
  );
}

export default App;
